import React from 'react';
import { bool, shape, string } from 'prop-types';

const PdfFileColor = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.5 1.5H4.5C3.675 1.5 3.0075 2.175 3.0075 3L3 15C3 15.825 3.6675 16.5 4.4925 16.5H13.5C14.325 16.5 15 15.825 15 15V6L10.5 1.5ZM4.5 15V3H9.75V6.75H13.5V15H4.5ZM10.5 12V9.75C10.5 9.3375 10.1625 9 9.75 9H8.25V12.75H9.75C10.1625 12.75 10.5 12.4125 10.5 12ZM9 9.75H9.75V12H9V9.75ZM12 11.25H12.75V10.5H12V9.75H12.75V9H11.25V12.75H12V11.25ZM6 11.25H6.75C7.1625 11.25 7.5 10.9125 7.5 10.5V9.75C7.5 9.3375 7.1625 9 6.75 9H5.25V12.75H6V11.25ZM6 9.75H6.75V10.5H6V9.75Z" fill="currentColor" />
  </svg>
);

PdfFileColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default PdfFileColor;
